export default __webpack_public_path__ + "static/media/file.98fe645c.png";